'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GetProviderResponse(type, id, name) {
  this.xD = null;
  this.M5 = null;
  this.EF = null;
  this.xD = type;
  this.M5 = id;
  this.EF = name;
}
export { $c_Lpresto_types$proto$GetProviderResponse as $c_Lpresto_types$proto$GetProviderResponse };
$p = $c_Lpresto_types$proto$GetProviderResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GetProviderResponse;
/** @constructor */
function $h_Lpresto_types$proto$GetProviderResponse() {
}
export { $h_Lpresto_types$proto$GetProviderResponse as $h_Lpresto_types$proto$GetProviderResponse };
$h_Lpresto_types$proto$GetProviderResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$GetProviderResponse)) {
    var x = this.xD;
    var x$2 = x$0.xD;
    if ((x === x$2)) {
      var x$3 = this.M5;
      var x$4 = x$0.M5;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.EF;
      var x$6 = x$0.EF;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "GetProviderResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xD;
      break;
    }
    case 1: {
      return this.M5;
      break;
    }
    case 2: {
      return this.EF;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$GetProviderResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.le)));
}
export { $isArrayOf_Lpresto_types$proto$GetProviderResponse as $isArrayOf_Lpresto_types$proto$GetProviderResponse };
var $d_Lpresto_types$proto$GetProviderResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GetProviderResponse, "presto.types$proto$GetProviderResponse", ({
  le: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$GetProviderResponse as $d_Lpresto_types$proto$GetProviderResponse };
//# sourceMappingURL=presto.types$proto$-Get-Provider-Response.js.map
